/* Fast String.prototype.startsWith for webOS 3 (Chromium 38) and every other
   legacy-bundle browser.

   Chrome 38 has no native startsWith (Chrome 41+), so the legacy polyfills
   install core-js's, which runs an IsRegExp check (classof + a Symbol.match
   lookup through the Symbol shim), ToString and ToLength on every call. shaka's
   XML parser (TXml) calls it all the time while parsing the MPD, and a 1h live
   channel re-parses an ~86 KB MPD every few seconds: core-js startsWith was
   6.7% of the main thread during steady playback on ch48 (plus the garbage it
   makes), most of the parser's self time.

   Installs a charCode compare for the plain case (string receiver, string
   search, number/undefined position) and hands anything else to core-js, so
   the RegExp TypeError and the coercions stay core-js's. Legacy build only: a
   modern bundle keeps the native startsWith. Imported from src/index.jsx with
   the other fast shims. */

const existingStartsWith = String.prototype.startsWith;
// eslint-disable-next-line no-underscore-dangle -- marker property, mirrors fastArrayFrom
const isInstalled = Boolean(existingStartsWith && existingStartsWith.__dtvFastStartsWith);
const CoreStartsWith = typeof existingStartsWith === 'function' && !isInstalled
  ? existingStartsWith
  : undefined;

/* eslint-disable unicorn/prefer-code-point, unicorn/prefer-reflect-apply -- charCodeAt
   compares UTF-16 units exactly like the spec; Reflect.apply would hit the core-js shim */

if (import.meta.env.LEGACY && CoreStartsWith) {
  // eslint-disable-next-line func-names -- keeps startsWith's own name
  const fastStartsWith = function startsWith(search, position) {
    if (typeof this !== 'string' || typeof search !== 'string'
      || (position !== undefined && typeof position !== 'number')) {
      // eslint-disable-next-line prefer-rest-params -- forward the call untouched
      return CoreStartsWith.apply(this, arguments);
    }
    const { length } = this;
    /* ToIntegerOrInfinity + clamp to [0, length]; NaN and negatives are 0. */
    const start = position > 0 ? Math.min(Math.floor(position), length) : 0;
    const end = start + search.length;
    if (end > length) return false;
    for (let index = 0; index < search.length; index += 1) {
      if (this.charCodeAt(start + index) !== search.charCodeAt(index)) return false;
    }
    return true;
  };
  // eslint-disable-next-line no-underscore-dangle -- marker property, mirrors fastArrayFrom
  fastStartsWith.__dtvFastStartsWith = true;
  // eslint-disable-next-line no-extend-native -- replaces the core-js polyfill, same semantics
  Object.defineProperty(String.prototype, 'startsWith', {
    configurable: true, enumerable: false, writable: true, value: fastStartsWith,
  });
}

/* eslint-enable unicorn/prefer-code-point, unicorn/prefer-reflect-apply -- end of block */
